import * as React from 'react';
import { useSelector } from 'react-redux';
import * as ReactDOMServer from 'react-dom/server';
import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import {
  getMapApiKey,
  getLocationCenterCoordinates,
  getFilteredResidentialComplexes,
  getResidentialComplexes,
} from '../../selectors';
import { Map as MapComponent } from '../../components/Map';
import { getPins } from './helpers';
import { MapBalloon } from '../MapBalloon';

export function Map() {
  const apiKey = useSelector(getMapApiKey);
  const { hash, list } = useSelector(getResidentialComplexes);
  const [pinTypes, setPinTypes] = React.useState<string[]>([]);
  const filteredComplexes = useSelector(getFilteredResidentialComplexes);
  const { center, zoom } = useSelector(getLocationCenterCoordinates);

  const handleGeoObjectsFirstFetch = (): Promise<IMapGeoObject[]> => {
    const pins = getPins(list);

    return Promise.resolve(pins);
  };

  const handleBalloonHtmlFirstFetch = (geoObject: IMapGeoObject) => {
    const numberedId = Number(geoObject.options.id);
    const complex = hash[numberedId];

    if (!complex) {
      return { html: Promise.reject(new Error('Не верный тип пина!')) };
    }

    return {
      html: Promise.resolve(ReactDOMServer.renderToStaticMarkup(<MapBalloon complex={complex} />)),
      closeSelector: '#close',
    };
  };

  React.useEffect(() => {
    setPinTypes(filteredComplexes.map(complex => String(complex.id)));
  }, [filteredComplexes]);

  return (
    <MapComponent
      apiKey={apiKey}
      pinCoordinates={center}
      zoom={zoom}
      currentTypes={pinTypes}
      onGeoObjectsFirstFetch={handleGeoObjectsFirstFetch}
      onCustomBalloonHtmlFetch={handleBalloonHtmlFirstFetch}
    />
  );
}
